export default __webpack_public_path__ + "static/media/Java.fdabd4e1.png";